export const defaultWidthHeightMap = new Map();
defaultWidthHeightMap.set('BuysideLogo', { width: '140px', height: '48px' });
defaultWidthHeightMap.set('BuysideSandPLogo', {
    width: '140px',
    height: '48px',
});
defaultWidthHeightMap.set('Calendar', { width: '17px', height: '16px' });
defaultWidthHeightMap.set('Change', { width: '18px', height: '15px' });
defaultWidthHeightMap.set('Chart', { width: '18px', height: '15px' });
defaultWidthHeightMap.set('Close', { width: '12px', height: '12px' });
defaultWidthHeightMap.set('Context', { width: '22px', height: '23px' });
defaultWidthHeightMap.set('Download', { width: '14px', height: '14px' });
defaultWidthHeightMap.set('Ellipsis', { width: '28px', height: '28px' });
defaultWidthHeightMap.set('Error', { width: '22px', height: '22px' });
defaultWidthHeightMap.set('ErrorIcon', { width: '52px', height: '52px' });
defaultWidthHeightMap.set('Heatmap', { width: '16px', height: '16px' });
defaultWidthHeightMap.set('Histogram', { width: '24px', height: '16px' });
defaultWidthHeightMap.set('Icicle', { width: '16px', height: '16px' });
defaultWidthHeightMap.set('Info', { width: '17px', height: '16px' });
defaultWidthHeightMap.set('IHSMarkitLogo', { width: '140px', height: '48px' });
defaultWidthHeightMap.set('LogoCollapsed', { width: '42px', height: '42px' });
defaultWidthHeightMap.set('LogOut', { width: '22px', height: '22px' });
defaultWidthHeightMap.set('SPLogoCollapsed', { width: '40px', height: '21px' });
defaultWidthHeightMap.set('TMRLogo', { width: '158px', height: '48px' });
defaultWidthHeightMap.set('PivotGrid', { width: '17px', height: '16px' });
defaultWidthHeightMap.set('Sankey', { width: '18px', height: '15px' });
defaultWidthHeightMap.set('Sunburst', { width: '22px', height: '22px' });
defaultWidthHeightMap.set('Table', { width: '21px', height: '18px' });
defaultWidthHeightMap.set('Tick', { width: '22px', height: '22px' });
defaultWidthHeightMap.set('TimeSeries', { width: '23px', height: '16px' });
defaultWidthHeightMap.set('TreeMap', { width: '18px', height: '18px' });
defaultWidthHeightMap.set('UserProfile', { width: '12px', height: '16px' });
defaultWidthHeightMap.set('ThemeSwitcher', { width: '22px', height: '22px' });
defaultWidthHeightMap.set('InputAttention', { width: '14px', height: '14px' });
defaultWidthHeightMap.set('Clear', { width: '10px', height: '10px' });
defaultWidthHeightMap.set('Search', { width: '14px', height: '14px' });
defaultWidthHeightMap.set('TickColorless', { width: '16px', height: '16px' });
defaultWidthHeightMap.set('ErrorColorless', { width: '16px', height: '16px' });
defaultWidthHeightMap.set('Edit', { width: '18px', height: '18px' });
defaultWidthHeightMap.set('Save', { width: '13px', height: '13px' });
//# sourceMappingURL=defaultIconValues.js.map